import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getBaseUrl() {
  if (process.env.NODE_ENV === "test") {
    return process.env.NEXT_PUBLIC_TEST_URL;
  }

  // On stagong the env var NEXT_PUBLIC_VERCEL_URL does not have protocol tied to it
  let baseURL =
    process.env.NEXT_PUBLIC_SITE_URL ?? process.env.NEXT_PUBLIC_VERCEL_URL;

  if (
    !baseURL?.startsWith("https://") &&
    !baseURL?.startsWith("http://localhost")
  ) {
    baseURL = "https://" + baseURL;
  }

  return baseURL;
}
